import React from 'react'
import { Check, LockKeyhole } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { formatOwnersPercent, getProgressView, getTierStyle } from '../utils/achievementFormat'

const AchievementCard = ({ achievement, language, onClick }) => {
  const { t } = useTranslation()
  const tier = getTierStyle(achievement.tier)
  const progress = getProgressView(achievement, t, language)

  return (
    <button
      type="button"
      onClick={() => onClick(achievement)}
      className={`block w-full overflow-hidden rounded-2xl border bg-surface p-3 text-left shadow-[inset_0_1px_0_rgba(255,255,255,0.07),0_10px_15px_-3px_rgba(0,0,0,0.25)] transition-all active:scale-[0.98] ${tier.border}`}
    >
      <div className="flex gap-3">
        <div className="relative h-20 w-20 shrink-0 rounded-xl bg-black/20 p-1">
          <div className="pointer-events-none absolute inset-2 rounded-full blur-xl" style={{ backgroundColor: tier.glow }} />
          <img src={achievement.image} alt={achievement.name} loading="lazy" className={`relative h-full w-full object-contain ${achievement.earned ? '' : 'grayscale opacity-40'}`} />
          <span className={`absolute bottom-0 right-0 flex h-6 w-6 items-center justify-center rounded-full border border-dark-primary ${achievement.earned ? 'bg-accent-primary text-dark-primary' : 'bg-gray-700 text-gray-300'}`}>
            {achievement.earned ? <Check size={13} strokeWidth={3} /> : <LockKeyhole size={12} />}
          </span>
        </div>

        <div className="min-w-0 flex-1 py-0.5">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <h3 className="truncate text-sm font-bold not-italic text-white">{achievement.name}</h3>
              <span className={`text-[9px] font-bold uppercase tracking-wider ${tier.text}`}>
                {t(`achievements.tiers.${achievement.tier}`, { defaultValue: achievement.tier })}
              </span>
            </div>
            <span className="shrink-0 text-[10px] tabular-nums text-text-secondary">
              {formatOwnersPercent(achievement.owners_pct, language)}%
            </span>
          </div>
          <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-text-secondary">{achievement.description}</p>
        </div>
      </div>

      {!achievement.earned && progress && (
        <div className="mt-3 border-t border-white/5 pt-2.5">
          <div className="text-[11px] text-text-secondary">{progress.label}</div>
          {progress.showBar && (
            <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-white/5">
              <div className="h-full rounded-full bg-gradient-to-r from-info to-accent-secondary" style={{ width: `${progress.ratio * 100}%` }} />
            </div>
          )}
        </div>
      )}
    </button>
  )
}

export default AchievementCard
